module.exports = __webpack_public_path__ + "img/arrow-right.7732c87d.svg";